<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from './ConsultantFormData';
    import Select from '$components/Form/Select.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const needTypeOptions = [
        'Études techniques / faisabilité',
        'Environnement / études d’impact',
        'Génie civil / BTP',
        'Urbanisme / aménagement',
        'Assistance à maîtrise d’ouvrage',
        'Formation / accompagnement',
        'Audit technique ou financier',
        'Autre besoin (précisez ci-dessous)',
    ].map((v) => ({ label: v, value: v, key: v }));

    const orgTypeOptions = [
        'Entreprise privée',
        'Collectivité locale',
        'Ministère / État',
        'ONG / bailleur',
        'Particulier / porteur de projet individuel',
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.needType}
        class=""
        let:field
        let:id
        label={`Type de besoin`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={needTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.orgType}
        class=""
        let:field
        let:id
        label={`Vous êtes un / une`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={orgTypeOptions}
        />
    </Row>
</div>
